// =============================================
// useHelpGuide — Hook לפתיחת מדריך עזרה
// Ctrl+/ פותח/סוגר את המדריך
// =============================================

import { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

export function useHelpGuide() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const user = useAuthStore(s => s.user);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen(prev => !prev), []);

  // Ctrl+/ listener (e.code = layout-independent, works for Hebrew keyboard too)
  // F1 as fallback (works in Chrome/Firefox, Edge may intercept)
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Ctrl+/ (or Cmd+/ on Mac) — e.code is layout-independent
      if (e.code === 'Slash' && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        toggle();
        return;
      }
      // F1 fallback (Edge may intercept, but works in Chrome/Firefox)
      if (e.key === 'F1') {
        e.preventDefault();
        e.stopImmediatePropagation();
        toggle();
      }
    };
    window.addEventListener('keydown', handleKeyDown, { capture: true });
    return () => window.removeEventListener('keydown', handleKeyDown, { capture: true });
  }, [toggle]);

  return {
    isOpen,
    open,
    close,
    toggle,
    currentPath: location.pathname,
    userRole: user?.role || null,
  };
}
